/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CorrectPaymentAccountReferenceRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CorrectIPaymentAccountReference.pb'
import {CorrectPaymentAccountReferenceResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CorrectIPaymentAccountReference.pb'


export const correctPaymentAccountReference = (request: CorrectPaymentAccountReferenceRequest, options?: CashRequestOptions) => post<CorrectPaymentAccountReferenceRequest, CorrectPaymentAccountReferenceResponse>("/2.0/cash/correct-payment-account-reference", request, {...options, rejectOnError: true })